import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Input from '../../../components/ui/Input';
import Select from '../../../components/ui/Select';

const EditProfileModal = ({ isOpen, onClose, coupleData, onSave }) => {
  const [formData, setFormData] = useState({
    relationshipGoals: coupleData?.relationshipGoals?.join(', '),
    location: coupleData?.location,
    privacyLevel: 'shared'
  });

  const privacyOptions = [
    { value: 'shared', label: 'Shared - Both partners see all data' },
    { value: 'private', label: 'Private - Some data kept separate' },
    { value: 'custom', label: 'Custom - Configure individual settings' }
  ];

  const handleInputChange = (field, value) => {
    setFormData(prev => ({
      ...prev,
      [field]: value
    }));
  };

  const handleSubmit = (e) => {
    e?.preventDefault();
    onSave(formData);
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-modal flex items-center justify-center p-4 bg-background/80 backdrop-blur-sm">
      <div className="bg-card rounded-lg border border-border shadow-therapeutic-lg w-full max-w-2xl max-h-[90vh] overflow-y-auto">
        <div className="sticky top-0 bg-card border-b border-border p-4 md:p-6 flex items-center justify-between">
          <h2 className="text-xl md:text-2xl lg:text-3xl font-heading font-semibold text-foreground">
            Edit Profile Settings
          </h2>
          <button
            onClick={onClose}
            className="flex items-center justify-center w-8 h-8 rounded-md hover:bg-muted transition-therapeutic"
          >
            <Icon name="X" size={20} color="var(--color-foreground)" />
          </button>
        </div>

        <form onSubmit={handleSubmit} className="p-4 md:p-6 space-y-4 md:space-y-6">
          <Input
            label="Relationship Goals"
            type="text"
            description="Separate multiple goals with commas"
            value={formData?.relationshipGoals}
            onChange={(e) => handleInputChange('relationshipGoals', e?.target?.value)}
            placeholder="e.g., Better communication, More intimacy"
          />

          <Input
            label="Location"
            type="text"
            value={formData?.location}
            onChange={(e) => handleInputChange('location', e?.target?.value)}
            placeholder="City, State"
          />

          <Select
            label="Privacy Level"
            description="Control how data is shared between partners"
            options={privacyOptions}
            value={formData?.privacyLevel}
            onChange={(value) => handleInputChange('privacyLevel', value)}
          />

          <div className="bg-muted/30 rounded-lg p-4 border border-border">
            <div className="flex items-start gap-3">
              <Icon name="Info" size={20} color="var(--color-primary)" className="flex-shrink-0 mt-0.5" />
              <div>
                <p className="text-sm md:text-base text-foreground font-medium mb-1">
                  Privacy & Security
                </p>
                <p className="text-xs md:text-sm text-muted-foreground">
                  Your intimate data is encrypted and never shared with third parties. Both partners must consent to any changes in privacy settings.
                </p>
              </div>
            </div>
          </div>

          <div className="flex flex-col-reverse sm:flex-row gap-3 pt-4">
            <Button
              type="button"
              variant="outline"
              onClick={onClose}
              fullWidth
              className="sm:flex-1"
            >
              Cancel
            </Button>
            <Button
              type="submit"
              variant="default"
              fullWidth
              className="sm:flex-1"
            >
              Save Changes
            </Button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default EditProfileModal;